import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveComponent as _resolveComponent, withCtx as _withCtx, createBlock as _createBlock, createVNode as _createVNode, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode } from "vue"

const _hoisted_1 = { class: "p-2 faq" }
const _hoisted_2 = { class: "text-title-underline" }
const _hoisted_3 = { class: "bg-white rounded mb-4 pb-1" }
const _hoisted_4 = /*#__PURE__*/_createElementVNode("h2", { class: "text-xl rounded-t font-semibold text-white bg-tradelaboBlueLight pl-2" }, " 目次 ", -1)
const _hoisted_5 = ["href"]
const _hoisted_6 = ["id"]
const _hoisted_7 = { class: "text-subtitle-underline" }
const _hoisted_8 = { class: "flex items-center px-4 font-semibold" }
const _hoisted_9 = /*#__PURE__*/_createElementVNode("div", { class: "text-tradelaboBlueLight text-base" }, "Q.", -1)
const _hoisted_10 = { class: "px-2 text-gray-600" }
const _hoisted_11 = { class: "px-4" }
const _hoisted_12 = { class: "flex items-start" }
const _hoisted_13 = /*#__PURE__*/_createElementVNode("div", { class: "font-semibold text-tradelaboBlueLight text-base" }, "A.", -1)
const _hoisted_14 = ["innerHTML"]
const _hoisted_15 = /*#__PURE__*/_createTextVNode(" よくあるご質問が見つかりませんでした。 ")

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_el_collapse_item = _resolveComponent("el-collapse-item")!
  const _component_el_collapse = _resolveComponent("el-collapse")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("h1", _hoisted_2, _toDisplayString(_ctx.t('contact_faq.title')), 1),
    (_ctx.toArray(_ctx.faqCategories).length)
      ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
          _createElementVNode("div", _hoisted_3, [
            _hoisted_4,
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.faqCategories, (faqCategory) => {
              return (_openBlock(), _createElementBlock("ul", {
                key: faqCategory.id,
                class: "my-2 ml-4"
              }, [
                _createElementVNode("li", null, [
                  _createElementVNode("a", {
                    class: "no-underline hover:underline font-semibold text-gray-600",
                    href: '#'+ faqCategory.id
                  }, "・" + _toDisplayString(faqCategory.name), 9, _hoisted_5)
                ])
              ]))
            }), 128))
          ]),
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.faqCategories, (faqCategory) => {
            return (_openBlock(), _createElementBlock("div", {
              key: faqCategory.id,
              class: "mb-6"
            }, [
              _createElementVNode("div", {
                id: faqCategory.id,
                class: "pt-14 -mt-14 scroll-target"
              }, [
                _createElementVNode("h4", _hoisted_7, _toDisplayString(faqCategory.name), 1),
                _createVNode(_component_el_collapse, {
                  modelValue: _ctx.activeName,
                  "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.activeName) = $event)),
                  accordion: ""
                }, {
                  default: _withCtx(() => [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(faqCategory.faqs, (faq) => {
                      return (_openBlock(), _createBlock(_component_el_collapse_item, {
                        key: faq.id,
                        name: faq.id
                      }, {
                        title: _withCtx(() => [
                          _createElementVNode("div", _hoisted_8, [
                            _hoisted_9,
                            _createElementVNode("div", _hoisted_10, _toDisplayString(faq.question), 1)
                          ])
                        ]),
                        default: _withCtx(() => [
                          _createElementVNode("div", _hoisted_11, [
                            _createElementVNode("div", _hoisted_12, [
                              _hoisted_13,
                              _createElementVNode("div", {
                                class: "v-html whitespace-pre-wrap mb-6 px-2",
                                innerHTML: faq.answer
                              }, null, 8, _hoisted_14)
                            ])
                          ])
                        ]),
                        _: 2
                      }, 1032, ["name"]))
                    }), 128))
                  ]),
                  _: 2
                }, 1032, ["modelValue"])
              ], 8, _hoisted_6)
            ]))
          }), 128))
        ], 64))
      : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
          _hoisted_15
        ], 64))
  ]))
}